import { render, staticRenderFns } from "./ModalDefault.vue?vue&type=template&id=30b434f2&scoped=true&"
import script from "./ModalDefault.vue?vue&type=script&lang=js&"
export * from "./ModalDefault.vue?vue&type=script&lang=js&"
import style0 from "./ModalDefault.vue?vue&type=style&index=0&id=30b434f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b434f2",
  null
  
)

export default component.exports